import * as React from 'react';
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { Description } from './static-details';
export var ActivityPreload = function (_a) {
  var activity = _a.activity;
  var primary = activity.primary;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "data-testid": "image-gallery-container",
    className: "gallery-container"
  }, React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, React.createElement(UitkImage, {
    alt: activity.image ? activity.image.description : 'image',
    src: activity.image && activity.image.url
  }))), React.createElement(UitkSpacing, {
    padding: {
      block: 'three',
      inline: 'three'
    }
  }, React.createElement("div", null, React.createElement(UitkHeading, {
    tag: "h2",
    size: 4
  }, primary.text), React.createElement("span", {
    className: "uitk-type-300"
  }, activity.supplierName))), activity.description && React.createElement(Description, {
    description: activity.description
  }), React.createElement(UitkSpacing, {
    padding: {
      block: 'three',
      inline: 'three'
    }
  }, React.createElement("div", null, React.createElement(UitkSpacing, {
    margin: {
      blockend: 'two'
    }
  }, React.createElement(UitkCardPlaceholder, {
    startPhase: "dark"
  })), React.createElement(UitkCardPlaceholder, null))));
};